import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { EquipmentStateName } from '@frontend/equipment/types';
import { CommonMessage } from '@frontend/lang';
import React from 'react';

import useEquipmentStateSelectV2 from './equipment-state-select-v2.controller';

const ID = 'equipment-state-select-v2';
export interface EquipmentStateSelectV2Props extends Omit<SelectInputV2Props<EquipmentStateName>, 'options'> {
    subset?: string[];
    includeAnyState?: boolean;
    anyStateLabel?: string;
    anyStateDisplay?: React.ReactNode;
}

export const EquipmentStateSelectV2 = (props: EquipmentStateSelectV2Props) => {
    const viewProps = useEquipmentStateSelectV2(props);
    return (
        <SelectInputV2<EquipmentStateName>
            {...props}
            id={ID + props.id}
            className='w-full'
            label={props.label || CommonMessage.OBJECTS.EQUIPMENT.STATUS}
            options={viewProps.options}
        />
    );
};
